const array = [
  {
    path: '/administrador/eventos/conf/participants/:id',
    name: 'event_conf_participants',
    props: true,
    component: () => import('./pages/EventConfParticipant.vue'),
    meta: {
      layout: 'admin',
      requiresAuth: true,
      pageTitle: 'Participantes',
      breadcrumb: [
        {
          text: 'Listagem de participantes',
          active: true,
        },
      ],
    },
  },

]

export default array
